import {Component} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import appLib from "../../../libs/appLib.mjs";
import MultiColumnBrowserContainer from "../../../controls/MultiColumnBrowser/MultiColumnBrowserContainer.mjs";
import MultiColumnBrowserColumn from "../../../controls/MultiColumnBrowser/MultiColumnBrowserColumn.mjs";

const prefix = "SimulationFlowSettings2CvesModal";


const SimulationFlowSettings2CvesModal = class extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.click = this.click.bind(this);
		this.close = this.close.bind(this);
		this.load = this.load.bind(this);
	}
	componentDidMount() {
		this.load();
	}
	load() {
		appLib.api("perimetri/graph", { id: this.props.peri }).then( res => {
			const node = res.nodes.find( n => ( n.data.id === this.props.source ) );
			const subjectNode = res.nodes.find( n => ( n.data.id === node.data.subject ) );
			console.log( node );
			this.setState({
				risorsa: node.data.id,
				risorsaLabel: node.data.name,
				risorsaType: node.data.type,
				risorsaSubType: node.data.nodeType,
				subject: subjectNode.data.id,
				subjectLabel: subjectNode.data.name,
			});
		})
	}
	close() {
		if (typeof this.props.close === 'function') {
			this.props.close();
		}
	}
	click( w ) {
		if (typeof this.props.save === 'function') {
			const arg = {
				graph: true,
				value: w.value,
				score: w.src.finalScore,
				risorsa: this.state.risorsa,
				risorsaLabel: this.state.risorsaLabel,
				subject: this.state.subject,
				subjectLabel: this.state.subjectLabel
			};
			this.props.save( arg );
		}
	}
	render() {
		if ( ! this.state.subject ) return null;
		return (
			<Modal
				className={prefix}
				isOpen={true}
				toggle={this.close}
				fade={false}
				onOpened={appLib.modalAutoFocus}
			>
				<ModalHeader toggle={this.close}>
					{ this.state.risorsaType }, { this.state.risorsaSubType }
				</ModalHeader>
				<ModalBody>
					{ this.state.risorsaLabel }
					<MultiColumnBrowserContainer
						style={{height: "400px"}}
					>
						<MultiColumnBrowserColumn
							width={"100%"}
							options={ this.props.cves}
							onClick={ this.click}
						/>
					</MultiColumnBrowserContainer>
				</ModalBody>
			</Modal>
		)
	}
}

export default SimulationFlowSettings2CvesModal;
